<script lang="ts" setup>
import { useDateTime, useOrder } from "@/composables";
import { useAppStore } from "@/store/app.store";
import type { TripMonitorRouteStop } from "@/api/trips/dto/trip-monitor";
import type { TripRouteStop } from "@/views/trips/edit/trip";

const { getTimeInterval, getTimeType } = useOrder();
const { dateTZ } = useDateTime();

const appStore = useAppStore();

const props = defineProps<{
  routeStop: TripMonitorRouteStop | TripRouteStop;
}>();
</script>

<template>
  <div v-if="props.routeStop.time2Type && props.routeStop.time2To">
    <div>Second time frame</div>
    <div v-if="appStore.dispatcher?.timezone">
      <span>{{ getTimeType(props.routeStop.time2Type) }}: </span>
      <span v-if="props.routeStop.time2From">
        {{ getTimeInterval(props.routeStop.time2From, props.routeStop.time2To, appStore.dispatcher?.timezone) }}
      </span>
      <span v-else>
        {{ dateTZ(props.routeStop?.time2To, appStore.dispatcher.timezone) }}
      </span>
    </div>
    <div v-if="props.routeStop?.timezone">
      <span>{{ getTimeType(props.routeStop?.time2Type) }}: </span>
      <span v-if="props.routeStop.time2From">
        {{ getTimeInterval(props.routeStop.time2From, props.routeStop.time2To, props.routeStop.timezone) }}
      </span>
      <span v-else>
        {{ dateTZ(props.routeStop?.time2To, props.routeStop.timezone) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
